"use strict";
import { popupRegistry } from "components/Popups/registry";
import { PopupType } from "components/Popups/types";
import {
  addTransactionBreadcrumb,
  getSwapTransactionInfo,
  handleSignatureStep
} from "state/sagas/transactions/utils";
import { addSignature } from "state/signatures/reducer";
import { SignatureType } from "state/signatures/types";
import { call, put } from "typed-redux-saga";
import { UniswapXOrderStatus } from "types/uniswapx";
import { submitOrder } from "uniswap/src/data/apiClients/tradingApi/TradingApiClient";
import { Routing } from "uniswap/src/data/tradingApi/__generated__";
import { HandledTransactionInterrupt } from "uniswap/src/features/transactions/errors";
import { slippageToleranceToPercent } from "uniswap/src/features/transactions/swap/utils/format";
export function* handleUniswapXSignatureStep(params) {
  const { analytics, step, trade } = params;
  const { quote, routing } = trade.quote;
  const orderHash = quote.orderId;
  const chainId = trade.inputAmount.currency.chainId;
  const signatureDetails = getUniswapXSignatureInfo(step, trade, chainId, routing);
  const analyticsParams = {
    trade,
    allowedSlippage: slippageToleranceToPercent(trade.slippageTolerance),
    fiatValues: {
      amountIn: analytics.token_in_amount_usd,
      amountOut: analytics.token_out_amount_usd,
      feeUsd: analytics.fee_usd
    },
    portfolioBalanceUsd: analytics.total_balances_usd
  };
  const signature = yield* call(handleSignatureStep, params);
  if (Date.now() / 1e3 > step.deadline) {
    throw new HandledTransactionInterrupt("User signed after deadline");
  }
  addTransactionBreadcrumb({ step, data: { routing, ...signatureDetails.swapInfo }, status: "in progress" });
  try {
    yield* call(submitOrder, { signature, quote, routing });
  } catch (error) {
    throw error;
  }
  yield* put(addSignature(signatureDetails));
  popupRegistry.addPopup({ type: PopupType.Order, orderHash }, orderHash);
}
const ROUTING_TO_SIGNATURE_TYPE_MAP = {
  [Routing.DUTCH_V2]: SignatureType.SIGN_UNISWAPX_V2_ORDER,
  [Routing.DUTCH_V3]: SignatureType.SIGN_UNISWAPX_V3_ORDER,
  [Routing.PRIORITY]: SignatureType.SIGN_PRIORITY_ORDER
  // [Routing.LIMIT_ORDER]: SignatureType.SIGN_LIMIT,
};
function getUniswapXSignatureInfo(step, trade, chainId, routing) {
  const swapInfo = getSwapTransactionInfo(trade);
  return {
    type: ROUTING_TO_SIGNATURE_TYPE_MAP[routing],
    id: step.quote.orderId,
    addedTime: Date.now(),
    chainId,
    encodedOrder: trade.quote.quote.encodedOrder,
    offerer: trade.quote.quote.orderInfo.swapper,
    orderHash: trade.quote.quote.orderId,
    status: UniswapXOrderStatus.OPEN,
    swapInfo
  };
}
